/*eslint no-use-before-define:0 *///TODO REMOVE THIS
var dd = require('ES/lib/dd');
var _ = require('ES/lib/lodash');

module.exports = dd.createClass({
	render: function(){
		var event = this.props.event;

		return dd.div(null,
			dd.h4({className: 'section-head'}, 'Relay Opportunity'),
			dd.div(null,
				dd.div({}, 'This event is linked to a relay opportunity (' + _.get(event, ["relay"]) + ').'),
				dd.a({className: 'btn btn-default btn-sm pull-right', href: '/admin/pd-sales-relay/' + _.get(event, ["relay"]) + '/relay-full-detail'}, dd.i({className: 'fa fa-external-link'}), ' View Opportunity'),
				dd.div({className: 'clearfix'})
			)
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/library/RelayOpportunity.js